var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_53_31",
    transform: "translate(0.0238095) scale(0.010582 0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_53_31",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAACP0lEQVR4nO3dvWoVURiF4TcJKBHtUmhiqeQSbASrWNlbeQdGiM2xsbK2ESFCwE4vxCKxPCCId5DOgEmQxCIWk4DoOWSc75u152c9sMud2bwM80dmDpiZmZmZmY3IQ2AH+AYcAWc9HEfAZ+AZcDU3T9w68InykbLHFLid2CnkAXBA+Shtxi6+Z68z7MgXYzMrWFNDPFzMGntZwZrYmLOoIY4fkVCLkcnA4+D8PrkRmRwNfT84fzQWgvMPgesZC+mJxr2ioc+C8/umca/oocNqcmgRhxZxaBGHFnFoEYcWcWiRroQ+BSbAGtVNQfZYA16cb6eXsp6MTUTrnQTXWUxW6Fui9d4MrrOxrhw6os9c6loSbecfXQn9ZGDbSZd16DihOn6utrTO1fO/fxJcZ2N+TPp//Ji06xxaxKFFHFrEoUUcWsShRRxaxKFFHFrEoUUcWsShRRxaxKFFHFrEoUUcWsShRRxaxKFFHFrEoUUcWsShRRxaxKFFHFrEoUUcur6iH0YZk6+RyQ5d34fIZP8jej1T4B6B1+e8R19uCjyi8DuKqi90qcchsAs8Ba6k1QqYt9CfwBbVe32WYF7orZKLGqJ5ob0n/yV6MtxPWcUIRF/ZXWH2Rwb3Kfwtz6G5RnVrOutk+Bzdy/Sj8J7yl2NtjgPgLbCcFaypu1QX86WDtD3eZQWLeEn5EG2PYzpwJ70IfKR8jMGHhuoK5hXwi/JR2hjbealy3AFeA1/o78+D/Dm+A2/owMnQzMzMzMysFb8BZ3NoQP9Ofe0AAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.b4463b99ed68d6f7f516029fc8f0a7b4.svg";
export { ForwardRef as ReactComponent };